import { createThemeStore, FAMILY_THEME_CONFIG, type ThemeConfig, type ThemeStore } from "@jkast90/kast-common/theme";
import { onPreferencesApplied, setPref } from "./preferences";

// The family themes (System, Light, Dark, High contrast) on kast-common's
// theme store. The choice is a setting like the others (preferences.ts
// KEYS), so it follows the account: a choice goes through setPref, and the
// account's arrives through onPreferencesApplied. index.html's boot script is generated from
// the same config (theme.test.ts keeps them in step).
export const THEME_KEY = "pocket-play.theme";

export const themeConfig: ThemeConfig = { storageKey: THEME_KEY, ...FAMILY_THEME_CONFIG };

const store = createThemeStore(themeConfig);

/** The store, with a choice sent to the account too: what the ThemePicker is given. */
export const themeStore: ThemeStore = {
  ...store,
  setMode(mode) {
    setPref(THEME_KEY, mode);
    store.setMode(mode);
  },
};

/** Takes the account's choice when its settings arrive. Call once at load. */
export function followAccountTheme(): () => void {
  return onPreferencesApplied(() => {
    const saved = localStorage.getItem(THEME_KEY);
    const mode = saved && store.modes.includes(saved) ? saved : "system";
    if (mode !== store.getState().mode) store.setMode(mode);
  });
}
